var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      [
        _c("div", { staticClass: "va-subtitle flex align-center" }, [
          _vm._v(" " + _vm._s(_vm.$t("roomCommands.title")) + " ")
        ]),
        _c(
          "va-card",
          { staticClass: "fit-height mb-6" },
          [
            _c("div", { staticClass: "va-subtitle-s" }, [
              _vm._v(_vm._s(_vm.$t("common.roomName")))
            ]),
            _c("va-text-field", {
              staticClass: "mb-5",
              attrs: {
                rules: [_vm.maxLength(_vm.room.name, 255)],
                label: _vm.$t("common.roomName"),
                dense: "",
                disabled: _vm.commandControlsDisabled
              },
              model: {
                value: _vm.room.name,
                callback: function($$v) {
                  _vm.$set(_vm.room, "name", $$v)
                },
                expression: "room.name"
              }
            }),
            _c(
              "div",
              { staticClass: "d-flex flex-row-reverse" },
              [
                _c("va-button", {
                  attrs: {
                    size: "s",
                    disabled:
                      _vm.sending ||
                      !_vm.room.name ||
                      _vm.commandControlsDisabled,
                    cta: _vm.$t("common.save")
                  },
                  on: { click: _vm.setName }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "va-card",
          { staticClass: "fit-height mb-6" },
          [
            _c("div", { staticClass: "va-subtitle-s" }, [_vm._v("Room info")]),
            _c("v-select", {
              attrs: {
                outlined: "",
                dense: "",
                attach: "",
                multiple: "",
                items: _vm.tags,
                "return-object": "",
                "item-value": "id",
                "item-text": "name",
                label: _vm.$t("common.tags"),
                loading: _vm.updatingTags,
                disabled: _vm.updatingTags || _vm.room.isMaintenanceExpired
              },
              model: {
                value: _vm.selectedTags,
                callback: function($$v) {
                  _vm.selectedTags = $$v
                },
                expression: "selectedTags"
              }
            }),
            _vm.groups && _vm.groups.length > 0
              ? _c("v-select", {
                  attrs: {
                    outlined: "",
                    dense: "",
                    attach: "",
                    items: _vm.groups,
                    "item-value": "id",
                    "item-text": "name",
                    "return-object": "",
                    loading: _vm.updatingGroup,
                    disabled:
                      _vm.updatingGroup || _vm.room.isMaintenanceExpired,
                    label: _vm.$t("common.group")
                  },
                  model: {
                    value: _vm.group,
                    callback: function($$v) {
                      _vm.group = $$v
                    },
                    expression: "group"
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "va-card mb-6" },
          [
            _c("div", { staticClass: "va-subtitle flex align-center" }, [
              _vm._v(" " + _vm._s(_vm.$t("common.policies")) + " ")
            ]),
            _c("policies-chooser", {
              attrs: {
                policies: _vm.room.policies,
                "is-room": "",
                "is-android": true,
                disabled: _vm.room.isMaintenanceExpired
              }
            })
          ],
          1
        ),
        _vm.room
          ? _c("remote-providers", { attrs: { room: _vm.room } })
          : _vm._e(),
        _c("logging-android", { staticClass: "va-card mb-6" }),
        _c("room-last-commands", { staticClass: "va-card mb-6" })
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }